'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.675 18.908c0-.16.043-.281.129-.363.085-.082.21-.123.374-.123.159 0 .28.042.368.126.087.083.13.204.13.36a.477.477 0 0 1-.132.356.495.495 0 0 1-.366.13c-.16 0-.284-.042-.371-.127a.476.476 0 0 1-.132-.359Zm.092-.978v-.212c0-.183.038-.342.117-.477.078-.136.22-.28.429-.432.2-.143.332-.26.396-.349a.507.507 0 0 0 .096-.301.325.325 0 0 0-.138-.283c-.091-.065-.22-.097-.383-.097-.286 0-.612.094-.978.28l-.312-.626a2.727 2.727 0 0 1 1.353-.357c.393 0 .705.094.937.283.23.188.347.44.347.755a.998.998 0 0 1-.143.543c-.095.153-.276.324-.543.515-.183.135-.3.238-.348.309a.483.483 0 0 0-.072.277v.172h-.758Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.973 20.335V21H3.93v-.665h1.043Zm2.087 0V21H6.017v-.665H7.06Zm2.086 0V21H8.103v-.665h1.043Zm2.087 0V21H10.19v-.665h1.043Zm2.086 0V21h-1.043v-.665h1.043Zm2.087 0V21h-1.043v-.665h1.043Zm2.087 0V21H16.45v-.665h1.043Zm2.086 0V21h-1.043v-.665h1.043Zm1.65-.311.245.496a.332.332 0 0 1-.298.48h-.554v-.665h.02l-.009-.017.596-.294Zm-18.95 0 .596.294-.008.017h.02V21h-.555a.332.332 0 0 1-.298-.48l.245-.496Zm8.211-3.247c.16 0 .294.114.325.266l.007.067v1.648h1.213v.665H4.64v-.665h1.213V17.11c0-.161.113-.295.265-.326l.067-.007h4.305Zm9.803 1.352.468.947-.596.296-.468-.948.596-.294Zm-17.077 0 .596.294-.468.949-.596-.296.468-.947Zm6.941-.687h-3.64v1.316h3.64v-1.316Zm9.2-1.207.468.948-.596.294-.468-.948.596-.294Zm-15.205 0 .596.294-.468.948-.596-.294.468-.948ZM18.616 6.172c.16 0 .294.115.325.266l.007.067v1.782a.333.333 0 0 1-.265.326l-.067.007H10.03l.01 7.492h-.665l-.002-1.72h-1.88l1.346 1.58-.337.289L7.3 14.849 7.3 16.11l-.664.002-.01-7.493H3.361a.332.332 0 0 1-.325-.266l-.007-.067V6.505c0-.16.113-.295.265-.326l.067-.006h15.255Zm-.195 8.17.468.947-.596.293-.468-.947.596-.293Zm-13.333 0 .596.293-.468.947-.596-.293.468-.947Zm4.28-2.457L7.51 13.949h1.861l-.003-2.063Zm8.041.828a.33.33 0 0 1 .298.185l.246.495-.596.295-.154-.312h-.348v-.663h.554Zm-11.608.184.596.294-.245.497-.596-.294.245-.497Zm3.364-1.447h-1.87l.002 2.073 1.868-2.072Zm6.732 1.262v.665h-.958v-.665h.958Zm-1.916 0v.665h-.958v-.665h.958Zm-1.917 0v.665h-.553v-.665h.553ZM7.291 8.928l.003 2.079h1.871L7.291 8.928Zm2.073-.309H7.61l1.757 1.95-.003-1.95Zm7.863-1.474-1.06.81h2.116v-.003l-1.056-.808ZM3.693 7.4v.554h.726L3.693 7.4Zm10.758-.256-1.058.81h2.118l-1.06-.81Zm-2.773 0-1.059.81h2.118l-1.059-.81Zm-2.773 0-1.059.81h2.118l-1.059-.81Zm-2.773 0-1.057.81h2.116l-1.059-.81Zm-.327-.306H3.693v.003l1.054.806 1.058-.81Zm11.094 0h-2.12l1.06.81 1.06-.81Zm-2.775 0h-2.118l1.06.81 1.058-.81Zm-2.773 0H9.233l1.06.81 1.058-.81Zm-2.774 0H6.46l1.058.81 1.06-.81Zm9.706 0h-.728l.728.556v-.556ZM8.121 3l.08.015 6.968 2.251-.204.633-6.804-2.198L5.34 5.848l-.402-.529 2.96-2.251a.329.329 0 0 1 .145-.063L8.122 3Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0CultivableUnsure = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0CultivableUnsure = FwSet0CultivableUnsure;